import { LeadCtx, TagGroupDto } from "@closerplatform/spinner-openapi";
import { observable } from "mobx";
import { IBreakingPointsInfo } from "@fidget/common/models/breakingPoints";
import { CurrentPage } from "@fidget/common/models/currentPage";
import { PickerWidgetMessages } from "@fidget/common/models/pickerWidgetMessages";
import { IUserService } from "@fidget/common/services/userService";
import { SharedPopupState } from "@fidget/common/store/sharedPopupStore";
import { IForeSpinnerService } from "../services/spinnerService";
import { UserService } from "../services/userService";
import { AbstractRoomState, IRoomState } from "./roomState";

export interface ForeState {
  room: IRoomState;
  profile?: LeadCtx;
  tagGroup?: TagGroupDto;
  sideBarMode: boolean;
  chatIsVisible: boolean;
  shared: SharedPopupState;
  chatScrolledToBottom: boolean;
  currentPage: CurrentPage;
  tabIsActive: boolean;
  widgetIsActive: boolean;
  breakingPoints: IBreakingPointsInfo;
  pendingMeetingToken?: string;
  profileLoadedCounter: number; // fixme: current user store is not adapted to handle async flow, so this is needed until refactor
  pickerWidgetMessages?: PickerWidgetMessages;
}

export class GuestRoomState extends AbstractRoomState {
  constructor(userService: IUserService, spinnerService: IForeSpinnerService) {
    super(userService, spinnerService);
  }
}

export class ForeStore {
  userService: IUserService;
  @observable
  state: ForeState;

  constructor(sharedPopupState: SharedPopupState, spinnerService: IForeSpinnerService) {
    this.userService = new UserService(this);
    this.state = this.init(sharedPopupState, spinnerService);
  }

  reset(sharedPopupState: SharedPopupState, spinnerService: IForeSpinnerService) {
    this.state = this.init(sharedPopupState, spinnerService);
  }

  private init(shared: SharedPopupState, spinnerService: IForeSpinnerService): ForeState {
    return {
      profileLoadedCounter: 0,
      sideBarMode: false,
      chatIsVisible: false,
      room: new GuestRoomState(this.userService, spinnerService),
      shared,
      chatScrolledToBottom: true,
      currentPage: {
        url: undefined,
        title: undefined
      },
      tabIsActive: true,
      widgetIsActive: false,
      breakingPoints: {
        isMobile: false,
        shouldCallDrawerBeHidden: false
      }
    };
  }
}
